import React from 'react';
import { IconUsers, IconHeart, IconUserCheck, IconShieldCheck } from '@tabler/icons-react';

const StatCard = ({ label, value, icon: Icon, iconColor }) => {
 return (
 <div className="bg-surface-1 border border-glass-border p-3 sm:p-6">
 <h3 className="text-sm sm:text-lg font-semibold mb-2 sm:mb-4 text-text-primary">{label}</h3>
 <div className="flex items-center">
 <Icon className={`h-6 w-6 sm:h-8 sm:w-8 ${iconColor} mr-2 sm:mr-3`} />
 <div>
 <p className="text-xl sm:text-2xl font-bold text-text-primary">
 {value}
 </p>
 </div>
 </div>
 </div>
 );
};

const StatsRow = ({ campaign, creators }) => {
 const totalNeeded = campaign?.requiredCreators || 0;
 // De-duplicate by creatorId for unique creator count
 const uniqueCreatorIds = new Set(creators.map(c => c.creatorId || c._id));
 const totalReacted = uniqueCreatorIds.size;
 const assigned = creators.filter(c => c.groupId !== null).length;
 const verified = creators.filter(c => ['VERIFIED', 'PAID'].includes(c.deliveryStatus?.toUpperCase())).length;

 return (
 <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-6 mb-6">
 <StatCard label="Total Needed" value={totalNeeded} icon={IconUsers} iconColor="text-accent" />
 <StatCard label="Reacted" value={totalReacted} icon={IconHeart} iconColor="text-accent" />
 <StatCard label="Assigned" value={assigned} icon={IconShieldCheck} iconColor="text-accent" />
 <StatCard label="Verified" value={verified} icon={IconUserCheck} iconColor="text-accent" />
 </div>
 );
};

export default StatsRow;
